<template>
    <div>

        <div id="passwordreset" class="section bg-svg-rainoverforest2">
            <div class="overlay opacity-50"></div>

            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">
                        <h1 class="title color-white mb-5">Password Recovery</h1>

                        <p class="lead mb-5">Sorry, this page can only be accessed from your mobile device with Sleep Jar installed.</p>

                        <p class="lead mb-5">Please check your email on your mobile device and tap the "Change Password" button in the password recovery email.</p>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>


<script>
    export default {
        name: 'password_reset',
        metaInfo: {
            title: 'Password Recovery',
            meta: [
                {
                    'name': 'description',
                    'property': 'og:description',
                    'content': 'Forgot your password? No problem - you can reset it here.'
                }
            ]
        },
        data () {
            return {
            };
        },
        methods: {
        },
        computed: {
        },
        components: {
        },
        mounted(){
        }
    }
</script>
